import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["data"];
import { useMemo } from 'react';
import { useQuery } from 'data-fetching-client';
import { GET_CRM_SEARCH_FOR_FORMS_TOTAL, GET_CRM_SEARCH_FOR_FORMS_TOTAL_FIELD_NAME } from 'FormsUI/api/dataFetchingClient/queries/getCRMSearch';
const useFetchCRMSearchForTotal = ({
  objectTypeId
}) => {
  const _useQuery = useQuery(GET_CRM_SEARCH_FOR_FORMS_TOTAL, {
      variables: {
        objectTypeId
      }
    }),
    {
      data: unparsedData
    } = _useQuery,
    rest = _objectWithoutPropertiesLoose(_useQuery, _excluded);
  const data = useMemo(() => unparsedData ? unparsedData[GET_CRM_SEARCH_FOR_FORMS_TOTAL_FIELD_NAME] : undefined, [unparsedData]);
  return Object.assign({
    data
  }, rest);
};
export default useFetchCRMSearchForTotal;